// extracted by mini-css-extract-plugin
module.exports = {"event":"EventCalendarChild_event__R43U8","eventStart":"EventCalendarChild_eventStart__2yJ1Z","eventEnd":"EventCalendarChild_eventEnd__1F1Ja"};